module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/raindrops-a164ac4f8560e3bef832e0b9643f53c3.svg";